import type { CoursePricingModel } from '@/api/admin'

/** Mirrors backend PricingCalculator.CalculateTotal — a flat fee is charged once regardless of places. */
export function calculateTotal(
  pricingModel: CoursePricingModel,
  perPersonPrice: number | null,
  flatFeeAmount: number | null,
  places: number,
): number | null {
  if (pricingModel === 'FlatFee') return flatFeeAmount
  return perPersonPrice != null ? perPersonPrice * places : null
}

export function isPriced(
  pricingModel: CoursePricingModel,
  perPersonPrice: number | null,
  flatFeeAmount: number | null,
): boolean {
  return pricingModel === 'FlatFee' ? (flatFeeAmount ?? 0) > 0 : (perPersonPrice ?? 0) > 0
}

/** A short label for a price card/badge, e.g. "£40" or "£500 (up to 12)". */
export function formatPriceLabel(
  pricingModel: CoursePricingModel,
  perPersonPrice: number | null,
  flatFeeAmount: number | null,
  flatFeeCapacity: number | null,
  fmtMoney: (n: number) => string,
): string | null {
  if (pricingModel === 'FlatFee') {
    if (flatFeeAmount == null) return null
    return flatFeeCapacity != null
      ? `${fmtMoney(flatFeeAmount)} (up to ${flatFeeCapacity})`
      : `${fmtMoney(flatFeeAmount)} flat fee`
  }
  return perPersonPrice != null ? fmtMoney(perPersonPrice) : null
}
